export function sa() {
  $('[data-sa]').each(function () {
    const target = $(this);
    $(window).on('load scroll', function () {
      if (($(window).scrollTop() ?? 0) > (target.offset()?.top ?? 0) - 800 && !target.hasClass('on')) {
        target.addClass('on');
      }
    });
  });
}
